<template>
  <v-dialog v-model="dialog" width="800px">
    <v-card :disabled="loading">
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
        class=""
      ></v-progress-linear>
      <BarTitle title="cronograma" @close="close()"></BarTitle>
      <v-card-text>
        <v-row>
            <v-col style="font-weight: bold;font-size: 18px;color: black;" class="mb-4">
            <!-- {{ physical_schedule.composition.name }} -->
            </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-text-field
              v-model="date_start"
              label="Data Inicial"
              type="date"
              outlined
              :disabled="loading"
            ></v-text-field>
          </v-col>
          <v-col>
            <v-text-field
              v-model="date_end"
              label="Data Final"
              type="date"
              :disabled="loading"
              outlined
            ></v-text-field>
          </v-col>
          <v-col>
            <v-btn
              color="primary"
              @click="sendGenerateSchedule"
              :loading="loadingGenerate"
              :disabled="loadingGenerate"
              rounded
              x-large
              style=""
            >
              Gerar Cronograma
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div
              ref="tableContainer"
              class="table-drag-container"
              @mousedown="onDragStart"
            >
            <v-card outlined v-if="serviceSchedule.length > 0" :disabled="loading">
              <v-simple-table class="table_schedule" dense>
                <thead>
                  <tr>
                    <th style="font-size: 16px">MÊS</th>
                    <th class="text-right" style="font-size: 16px">R$</th>
                    <th class="text-center" style="font-size: 16px">(%) REALIZADA</th>
                    <th class="text-center" style="font-size: 16px">(%) ACUMULADA</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in serviceSchedule" :key="index">
                    <td style="font-size: 16px">
                      {{ formatMonth(item.month) }} / {{ item.year }}
                    </td>
                    <td style="font-size: 16px" class="text-right">
                      <v-edit-dialog
                        :return-value.sync="item.value"
                        @save="calcAll(item)"

                        large
                      >
                        <span class="editable">{{ formatMoney(item.value) }}</span>
                        <template v-slot:input>
                          <vuetify-money
                            v-model="item.value"
                            :options="{ currency: 'BRL', precision: 2 }"

                          />
                        </template>
                      </v-edit-dialog>
                      <!-- {{ formatMoney(item.hh) }} -->
                    </td>
                    <td style="font-size: 16px" class="text-center">
                      <v-edit-dialog
                        :return-value.sync="item.percentage"
                        @save="calcHHItem(item)"

                        large
                      >
                        <span class="editable">{{ formatMoney(item.percentage) }} %</span>
                        <template v-slot:input>
                          <vuetify-money
                            v-model="item.percentage"
                            :options="{ currency: 'BRL', precision: 2 }"

                          />

                          <!-- <v-text-field
                            v-model="item.percentage"
                            type="number"
                            min="0"
                            max="100"
                            suffix="%"
                            @input="(value) => (item.percentage = parseNumber(value))"
                          /> -->

                        </template>
                      </v-edit-dialog>
                    </td>
                    <td style="font-size: 16px" class="text-center">
                      {{ formatMoney(item.percentage_acumulated) }} %
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-card>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
      <v-divider class="mb-4"></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="save" color="primary" class="mb-2" x-large style="width: 150px">
          salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import BarTitle from "@/pages/Components/BarTitle.vue";
import { mapActions } from "vuex";
export default {
  components: {
    BarTitle,

  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    financial_schedule: { type: Object },
  },
  data() {
    return {
      loadingGenerate: false,
      serviceSchedule: [],
      loading: false,
      date_start: null,
      date_end: null,
      dialog: false,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      scrollStartX: 0,
      scrollStartY: 0,
    };
  },
  watch: {
    value(val) {
      this.dialog = val;
      if (val) {
        this.initialize();
      }
    },

    dialog(val) {
      this.$emit("input", val);
    },
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.onDragging);
    document.removeEventListener('mouseup', this.onDragEnd);
  },
  methods: {
    ...mapActions("BudgetFinancialSchedule", [
      "generateSchedule",
      "saveSchedule",
      "loadSchedule",
    ]),

    /**
     * Inicializa os dados do componente
     */
    initialize() {
      this.serviceSchedule = [];
      this.loading = false;

      this.date_start = this.financial_schedule.date_start;
      this.date_end = this.financial_schedule.date_end;

      this.loading = true;
      this.loadSchedule(this.financial_schedule.id)
        .then((response) => {
          this.serviceSchedule = response.data.financial_schedule_items	;
          this.date_start = response.data.date_start;
          this.date_end = response.data.date_end;
        })
        .catch(() => {
          this.$toast.error("Erro ao carregar o cronograma.");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * gera o cronograma físico do serviço
     */
    sendGenerateSchedule() {

      if (!this.date_start || !this.date_end) {
        this.$toast.error("Por favor, preencha as datas inicial e final.");
        return;
      }
      this.loadingGenerate = true;
      let data = {

        stage_id: this.financial_schedule.stage_id,
        date_start: this.date_start,
        date_end: this.date_end,
      };

      this.generateSchedule(data)
        .then((response) => {
          this.serviceSchedule = response.data;
        })
        .catch(() => {
          this.$toast.error("Não foi possível gerar o cronograma");
        })
        .finally(() => {
          this.loadingGenerate = false;
        });
    },

    save() {
      //msg só e possivel salvar se a pocentagem acumulada for = a 100%
      const lastItem = this.serviceSchedule[this.serviceSchedule.length - 1];
      if (Number(lastItem.percentage_acumulated).toFixed(2) != "100.00") {
        // Salvar o cronograma
        this.$toast.error("A soma das porcentagens realizadas deve ser 100%");
        return false;
      }

      if (!this.date_start || !this.date_end) {
        this.$toast.error("Por favor, preencha as datas inicial e final.");
        return;
      }

      this.loading = true;
      let data = {
        financial_schedule_id: this.financial_schedule.id,
        financial_schedule_items: this.serviceSchedule,
        date_start: this.date_start,
        date_end: this.date_end,
      };
      this.saveSchedule(data)
        .then((response) => {
          this.$toast.success("Cronograma salvo !");
          //atualiza o serviço físico na tela principal
          this.$emit("updatePhysicalSchedule", response.data);
          this.close();
        })
        .catch(() => {
          this.$toast.error("Erro ao salvar o cronograma.");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * Calcula o total de hh e percentagens
     */
    calcAll() {
      let hh_total = this.financial_schedule.hh_total;

      let previousCumulativePercentage = 0;
      this.serviceSchedule.forEach((item) => {
        item.percentage = (item.hh / hh_total) * 100;
        // percentagem acumulada
        item.percentage_acumulated =
          item.percentage + (previousCumulativePercentage || 0);
        previousCumulativePercentage = item.percentage_acumulated;
      });

      // this.totalHH = totalHH;
      // this.totalPercent = totalPercent;
    },
    /**
     * Calcula as hh da prcentengem editada
     */
    calcHHItem(item) {
      const hh_total = this.financial_schedule.hh_total;
      item.hh = (item.percentage / 100) * hh_total;
      // Atualiza a percentagem acumulada
      this.calcAll();
    },

    formatMonth(month) {
      const date = new Date();
      date.setMonth(month - 1); // Ajusta o mês, pois Date usa 0-11
      return date.toLocaleString("pt-BR", { month: "long" });
    },
    formatMoney(number) {
      number = this.parseNumber(number);
      return number.toLocaleString("pt-br", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },

    parseNumber(number) {
      if (isNaN(number)) {
        return 0;
      }
      let result = parseFloat(number);
      return result;
    },
    /** Fecha o dialog */
    close() {
      this.dialog = false;
    },
    onDragStart(e) {
      const container = this.$refs.tableContainer;
      if (!container) return;
      this.isDragging = true;
      this.dragStartX = e.clientX;
      this.dragStartY = e.clientY;
      this.scrollStartX = container.scrollLeft;
      this.scrollStartY = container.scrollTop;
      container.style.cursor = 'grabbing';
      document.addEventListener('mousemove', this.onDragging);
      document.addEventListener('mouseup', this.onDragEnd);
    },
    onDragging(e) {
      if (!this.isDragging) return;
      const container = this.$refs.tableContainer;
      if (!container) return;
      const dx = e.clientX - this.dragStartX;
      const dy = e.clientY - this.dragStartY;
      container.scrollLeft = this.scrollStartX - dx;
      container.scrollTop = this.scrollStartY - dy;
    },
    onDragEnd() {
      this.isDragging = false;
      const container = this.$refs.tableContainer;
      if (container) container.style.cursor = 'grab';
      document.removeEventListener('mousemove', this.onDragging);
      document.removeEventListener('mouseup', this.onDragEnd);
    },
  },
};
</script>

<style scoped>
h2 {
  color: #2c3e50;
}
.table_schedule td {
}
.editable {
  cursor: pointer;
  color: #1976d2;
  font-weight: bold;
}
.editable:hover {
  background-color: #f0f0f0;
}
.table-drag-container {
  overflow: auto;
  cursor: grab !important;
  max-height: 400px;
  user-select: none;
}
.table-drag-container .v-simple-table {
  width: max-content;
  min-width: 100%;
}
.table-drag-container >>> .v-data-table__wrapper {
  overflow: visible !important;
  max-width: none !important;
}
.table-drag-container:active {
  cursor: grabbing !important;
}
.table-drag-container * {
  cursor: inherit !important;
}
</style>
